import { ArrayHelper } from "@/Common/Helpers/ArrayHelper";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { LightPrivateBill } from "@/Patient/Api/PrivateBill/Dto/LightPrivateBill";

import styles from "./PlanSection.module.scss";

interface IPrivateBillsProps {
    bills: LightPrivateBill[];
}

function PrivateBill(props: IPrivateBillsProps): JSX.Element {
    const showPrivateBillPopup = (requestItem: LightPrivateBill): void => {
        if (requestItem.IsClosed || requestItem.IsLockedForEditing) {
            const op = new LocalEvent(LocalPatientOperations.MedicalNote.ShowPrivateBillPopup);
            op.AddItem("privateBill", requestItem);
            LocalEventDispatcher.dispatch(op);
        }
        else {
            const op = new LocalEvent(LocalPatientOperations.MedicalNote.ShowCreatedPrivateBillEditPopup);
            op.AddItem("privateBill", requestItem);
            LocalEventDispatcher.dispatch(op);
        }
    };

    const billsToDisplay = ArrayHelper.SortDynamic(props.bills, "Number");

    const result = isArrayNullOrUndefinedOrEmpty(billsToDisplay) ? null : (
        billsToDisplay.map(x => {
            const invalidStyle = x.IsInvalid ? "invalid-medical-item" : "";

            if (x.IsClosed && !x.IsInvalid) {
                return (
                    <div
                        key={x.PrivateBillId}
                        onClick={() => showPrivateBillPopup(x)}
                        className={"margin-xs-right pointer note-items-list " + invalidStyle}
                    >
                        <a><span className={invalidStyle}>#{x.Number}</span></a>
                    </div>
                );
            }
            else if (x.IsClosed && x.IsInvalid) {
                return (
                    <div
                        key={x.PrivateBillId}
                        onClick={() => showPrivateBillPopup(x)}
                        className={"red-text margin-xs-right pointer note-items-list " + invalidStyle}
                    >
                        <a><span className={invalidStyle}>#{x.Number}</span></a>
                    </div>
                );
            }
            else {
                return (
                    <div
                        key={x.PrivateBillId}
                        onClick={() => showPrivateBillPopup(x)}
                        className={"margin-xs-right pointer note-items-list " + invalidStyle}
                    >
                        <a className={styles.openInvalidBill}>
                            <span className={"underline " + invalidStyle}>#{x.Number}</span>
                        </a>
                    </div>
                );
            }
        })
    );

    return <>{result}</>;
}

export { PrivateBill };
